












helpers = require('../../../helpers.coffee')

view_model = {
  data: ->
    contact: null
    flow: null

  methods:
    openResetContactSameFlowConfirmationModal: (data) ->
      @contact = data.contact
      @flow = data.flow
      EventsBus.$emit 'confirm-modal-show', id: 'confirm-reset-same-flow'

    callResetContact: ->
      @resetContactRecipient(@contact)

  created: ->
    EventsBus.$on 'Contact::SameFlowConfirmationModal', @openResetContactSameFlowConfirmationModal
    @contact_resource = new ContactsResource Session.current_company.id

  beforeDestroy: ->
    EventsBus.$off 'Contact::SameFlowConfirmationModal', @openResetContactSameFlowConfirmationModal


}
exports.default = helpers.vue_include(view_model,helpers.contacts.list_wrapper)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/modals/reset_contact_modal.vue